var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "advisor-contact-cta rounded py-3 py-md-4",
      attrs: { id: "advisor-contact-cta" },
    },
    [
      _c("span", {
        staticClass:
          "text-md format-words font-weight-semi d-none d-md-block mb-3 custom-color px-3 px-md-4",
        domProps: { innerHTML: _vm._s(_vm.$sanitize(_vm.componentTitle)) },
      }),
      _c(
        "div",
        { staticClass: "px-3 px-md-4" },
        [
          _c("ci-button", {
            staticClass: "mb-4 w-100",
            attrs: {
              size: "md",
              label: _vm.$t("ui.views.users.show.contact_component.cta_button"),
              variant: "primary-filled",
            },
            on: { click: _vm.handleOpenModal },
          }),
        ],
        1
      ),
      _vm.showMessaging
        ? _c(
            "div",
            {
              staticClass:
                "menu-item d-flex align-items-center mb-1 cursor-pointer px-3 px-md-4",
              on: {
                click: function ($event) {
                  return _vm.$emit("send-message")
                },
              },
            },
            [
              _c("div", { staticClass: "mdi mdi-message-text mdi-24px mr-3" }),
              _c("span", {
                staticClass: "font-weight-semi flex-grow-1",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("ui.views.users.show.contact_component.send_message")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.showContact
        ? _c(
            "div",
            {
              staticClass:
                "menu-item d-flex align-items-center mb-1 cursor-pointer px-3 px-md-4",
              on: {
                click: function ($event) {
                  return _vm.$emit("show-address")
                },
              },
            },
            [
              _c("div", {
                staticClass: "mdi mdi-information-outline mdi-24px mr-3",
              }),
              _c("span", {
                staticClass: "font-weight-semi flex-grow-1",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("ui.views.users.show.contact_component.show_address")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass:
            "menu-item d-none d-md-flex align-items-center mb-1 cursor-pointer",
        },
        [
          _c(
            "div",
            { staticClass: "flex-grow-1" },
            [
              _c("ci-share", {
                attrs: {
                  "tracking-target": _vm.sharing.trackingTarget,
                  url: _vm.sharing.url,
                  title: _vm.$t(
                    "ui.views.users.show.contact_component.share_profile"
                  ),
                  description: "test",
                  "prevent-toggle": false,
                  professional: true,
                  buttonVariant: "inline-share-profile ghost-dark",
                  networks: _vm.sharingNetworks,
                  label: _vm.$t(
                    "ui.views.users.show.contact_component.share_profile"
                  ),
                  dropdownPosition: "right",
                  type: "user",
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }